import { useState, useEffect } from "react";
import {
  CreateBasicInfo,
  getBasicinfoCategory,
  getBasicinfoType,
  SeheduleApiCreate,
} from "../../../services/apis/EventMangement/CreateEventApi";
import {
  getCityApi,
  getCountryApi,
  getStateApi,
} from "../../../services/apis/EventMangement/CountryStateCityApi";
import { useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import uplodIcon from "../../../assets/images/upload-icon.png";
import DocImg from "../../../assets/images/doc-image.png";
import ReactQuill from "react-quill";
import MyMapComponent from "../common/MyMapComponent";
import BtnLoader from "../Loader/BtnLoader";
import { DatePicker, DateRangePicker, Stack } from "rsuite";
import { FaCalendar, FaClock } from "react-icons/fa";
import { BsCalendar2MonthFill } from "react-icons/bs";
import { format } from "date-fns";
import Swal from "sweetalert2";

const BasicInformation = ({ setEventId, setTabValue }) => {
  const [inputData, setInputData] = useState({
    user_id: "",
    event_title: "",
    event_type: "",
    start_date: new Date().toISOString().split("T")[0],
    start_time: "",
    end_date: "",
    end_time: "",
    country: "101",
    state: "",
    city: "",
    zip_code: "",
    address: "",
    description: "",
    latitude: "24.571270",
    longitude: "73.691544",
    venue_name: "",
    zoom_link: "",
    google_link: "",
    custom_link: "",
    event_category: "",
    cut_off_date: "",
  });

  const userData = useSelector((state) => state?.auth?.auth?.user);
  const [btnLoading, setBtnLoading] = useState(false);
  // shduele states--------------------------start
  const [manageMultiple, setManageMultiple] = useState(false);
  const [scheduleDates, setScheduleDates] = useState([]);
  const [dynamicSchedules, setDynamicSchedules] = useState([]); // Now an object to store schedules by date
  const [images, setImages] = useState([]);
  const [documents, setDocuments] = useState([]);

  // shduele states--------------------------end
  const [type, setType] = useState([]);
  const [category, setCategory] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [errors, setErrors] = useState({});

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputData({ ...inputData, [name]: value });
    // validateField(name, value);
  };

  const validate = () => {
    const newErrors = {};
    if (!inputData?.event_title?.trim())
      newErrors.event_title = "Event Name is required.";

    if (!inputData?.event_category?.trim())
      newErrors.event_category = "Event Category is required.";

    if (!inputData?.event_type?.trim())
      newErrors.event_type = "Event Type is required.";

    if(inputData?.event_type == "Hybrid" || inputData?.event_type == "Online" ){
        
        if (!inputData?.zoom_link?.trim())
            newErrors.zoom_link = "Zoom Link is required.";

        if (!inputData?.google_link?.trim())
            newErrors.google_link = "Google Link is required.";

        if (!inputData?.custom_link?.trim())
            newErrors.custom_link = "Custom Link is required.";
    }

    if (!inputData?.country) newErrors.country = "Country is required.";

    if (!inputData.state) {
      newErrors.state = "State is required";
    }

    if (!inputData.city) {
      newErrors.city = "City is required";
    }

    if (!inputData.zip_code) {
      newErrors.zip_code = "Zip Code is required";
    }

    if (!inputData.start_date) {
      newErrors.start_date = "Start Date is required";
    }

    if (!inputData.start_time) {
      newErrors.start_time = "Start Time is required";
    }

    if (!inputData.end_date) {
      newErrors.end_date = "End Date is required";
    }

    if (!inputData.end_time) {
      newErrors.end_time = "End Time is required";
    }

    if (!inputData.description) {
      newErrors.description = "Description is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const CreateSeheduleApi = async (Id) => {
    const Data = {
      // create_schedule_details: manageMultiple,
      create_schedule_details: dynamicSchedules,
      schedule_images: images,
      schedule_documents: documents,
    };
    // console.log(Data);
    try {
      const response = await SeheduleApiCreate(Id, Data);
      console.log(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      setBtnLoading(true);
      try {
        const formdata = {
          ...inputData,
          user_id: userData?._id,
        };
        const response = await CreateBasicInfo(formdata);
        if (response?.data?.success) {
          Swal.fire({
            icon: "success",
            title: "Event",
            text: response?.data?.message,
          });
          toast.success(response.data.message);
          setEventId(response.data?.data?._id);
          CreateSeheduleApi(response?.data?.data?._id);
          setTabValue("Packages");
        }
      } catch (error) {
        console.error("Error while submitting the form:", error);
        toast.error(error?.response?.data?.message);
      } finally {
        setBtnLoading(false);
      }
    } else {
      console.log("Form contains errors");
    }
  };

  const fetchInitialData = async () => {
    try {
      const countriesResponse = await getCountryApi();
      setCountriesList(countriesResponse.data?.countries);
      if (inputData?.country) {
        const statesResponse = await getStateApi(inputData.country);
        setStateList(statesResponse?.data?.states);
      }
      if (inputData?.state) {
        const citiesResponse = await getCityApi(
          inputData.country,
          inputData.state
        );
        setCityList(citiesResponse?.data?.cities);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, [inputData?.country, inputData?.state]);

  const fetchData = async () => {
    try {
      const response = await getCityApi(inputData?.country, inputData?.state);
      setCityList(response?.data?.cities);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    if (inputData?.state) {
      fetchData();
    }
  }, [inputData?.state]);

  useEffect(() => {
    const getBasicInformationType = async () => {
      // try {
      //     const response = await getBasicinfoType();
      //     setType(response?.data);
      // } catch (error) {
      //     console.log(error);
      // }
      try {
        const response = await getBasicinfoCategory();
        setCategory(response?.data);
      } catch (error) {
        console.log(error);
      }
    };

    getBasicInformationType();
  }, []);

  // Generate dates between start and end date
  const getDatesInRange = (start, end) => {
    let startDate = new Date(start);
    let endDate = new Date(end);
    let dates = [];
    while (startDate <= endDate) {
      dates.push(new Date(startDate));
      startDate.setDate(startDate.getDate() + 1); // Move to the next day
    }
    return dates;
  };

  // Update schedule dates when start and end dates change
  useEffect(() => {
    if (inputData.start_date && inputData.end_date) {
      const datesInRange = getDatesInRange(
        inputData.start_date,
        inputData.end_date
      );
      setScheduleDates(datesInRange);
    }
  }, [inputData.start_date, inputData.end_date]);

  const addNewSchedule = (date) => {
    const newSchedule = {
      title: "",
      start_time: "",
      end_time: "",
      description: "",
    };

    setDynamicSchedules((prevSchedules) => {
      const dateIndex = prevSchedules.findIndex(
        (schedule) => schedule.date === date
      );
      if (dateIndex !== -1) {
        const updatedSchedules = [...prevSchedules];
        updatedSchedules[dateIndex].events.push(newSchedule);
        return updatedSchedules;
      } else {
        return [...prevSchedules, { date, events: [newSchedule] }];
      }
    });
  };

  const deleteSchedule = (date, index) => {
    setDynamicSchedules((prevSchedules) => {
      return prevSchedules.map((item) =>
        item.date === date
          ? { ...item, events: item.events.filter((_, i) => i !== index) }
          : item
      );
    });
  };

  const handleRadioChange = (e) => {
    setManageMultiple(e.target.value === "detailed");
  };

  const handleImageChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalImages = images.length + selectedFiles.length;

    if (totalImages > 6) {
      alert("You can only upload up to 6 images.");
      return;
    }
    // Update state with new images
    setImages((prevImages) => [...prevImages, ...selectedFiles]);
  };

  const handleRemoveImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleDocumentChange = (event) => {
    const selectedFiles = Array.from(event.target.files); // Convert FileList to Array
    const totalDocuments = documents.length + selectedFiles.length;

    if (totalDocuments > 3) {
      alert("You can only upload up to 3 documents.");
      return;
    }

    // Update state with new documents
    setDocuments((prevDocs) => [...prevDocs, ...selectedFiles]);
  };

  const handleRemoveDocument = (index) => {
    setDocuments((prevDocs) => prevDocs.filter((_, i) => i !== index)); // Remove the selected document
  };

//   const handleQuillChange = (value) => {
//     setInputData((prevState) => ({
//       ...prevState,
//       description: value,
//     }));
//   };

  const handleQuillChange = (value) => {
    const text = value?.replace(/<[^>]*>?/gm, "");
    if (text?.length <= 500) {
        setInputData((prevState) => ({
        ...prevState,
        description: value,
      }));
      setErrors({
        ...errors,
        description: "",
      });
    } else {
      setErrors({
        ...errors,
        description: "Description cannot exceed 500 characters.",
      });
    }
  };

  const handleDateChange = (date, field) => {
    // Format the selected date to "yyyy-MM-dd"
    const formattedDate = format(date, "yyyy-MM-dd");

    setInputData({
      ...inputData,
      [field]: formattedDate, // Dynamically update either start_date or end_date
    });
  };

  // console.log("in",inputData)
  return (
    <>
      <ToastContainer />
      <form onSubmit={handleSubmit}>
        <div className="container-fluid my-0">
          {/* Basic Form Fields */}
          <div className="card profile-card card-bx">
            <div className="card-header">
              <h6 className="card-title">Basic Info</h6>
            </div>
            <div className="card-body">
              <div className="mb-3 row">
                <div className="col-md-6">
                  <label className="col-sm-6 col-form-label">
                    Event Name<span className="asterisk">*</span>
                  </label>
                  <input
                    name="event_title"
                    value={inputData?.event_title}
                    onChange={handleInputChange}
                    type="text"
                    className="form-control"
                    placeholder="Ex: ABC"
                    maxLength={80}
                  />
                  {errors.event_title && (
                    <small className="text-danger">{errors.event_title}</small>
                  )}
                </div>

                <div className="col-md-5">
                  <label className="col-sm-6 col-form-label">
                    Event Category<span className="asterisk">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="event_category"
                    onChange={handleInputChange}
                  >
                    <option>Select Event Category</option>
                    {category?.map((value) => (
                      <option value={value?._id}>{value?.type}</option>
                    ))}
                  </select>
                  {errors.event_category && (
                    <small className="text-danger">
                      {errors.event_category}
                    </small>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6">
                  <label className="col-sm-6 col-form-label">
                    Event Type<span className="asterisk">*</span>
                  </label>
                  <div className="form-check d-flex gap-5">
                    {/* {type?.map((value) => (
                        <div key={value?._id}>
                            <input
                                className="form-check-input"
                                type="radio"
                                name="event_type"
                                id={value?._id}
                                value={value?.type}
                                onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor={value?._id}>
                                {value?.type}
                            </label>
                        </div>
                    ))} */}

                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="event_type"
                        id="online"
                        value="Online"
                        checked={inputData.event_type === "Online"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor="online"
                      >
                        Online
                      </label>
                    </div>
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="event_type"
                        id="in-person"
                        value="In-Person"
                        checked={inputData.event_type === "In-Person"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor="in-person"
                      >
                        In-Person
                      </label>
                    </div>
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="event_type"
                        id="hybrid"
                        value="Hybrid"
                        checked={inputData.event_type === "Hybrid"}
                        onChange={handleInputChange}
                      />
                      <label
                        className="form-check-label cursor-pointer"
                        htmlFor="hybrid"
                      >
                        Hybrid
                      </label>
                    </div>
                  </div>
                  {errors.event_type && (
                    <small className="text-danger">{errors.event_type}</small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {(inputData?.event_type == "Online" ||
            inputData?.event_type == "Hybrid") && (
            <div className="card profile-card card-bx ">
              <div className="card-header">
                <h6 className="card-title">Online Event Details</h6>
              </div>
              <div className="card-body">
                <div className="mb-3 row">
                  <div className="col-sm-4">
                    <label className="col-sm-4 col-form-label">
                      Zoom<span className="asterisk">*</span>
                    </label>
                    <input
                      name="zoom_link"
                      value={inputData?.zoom_link}
                      onChange={handleInputChange}
                      type="url"
                      className="form-control"
                      placeholder="Ex: https://www.zoom.com/"
                    />
                    {errors.zoom_link && (
                      <small className="text-danger">{errors.zoom_link}</small>
                    )}
                  </div>

                  <div className="col-sm-4">
                    <label className="col-sm-4 col-form-label">
                      Google Meet<span className="asterisk">*</span>
                    </label>
                    <input
                      name="google_link"
                      value={inputData?.google_link}
                      onChange={handleInputChange}
                      type="url"
                      className="form-control"
                      placeholder="Ex: https://meet.google.com/"
                    />
                    {errors.google_link && (
                      <small className="text-danger">
                        {errors.google_link}
                      </small>
                    )}
                  </div>

                  <div className="col-sm-4">
                    <label className="col-sm-4 col-form-label">
                      Custom Link<span className="asterisk">*</span>
                    </label>
                    <input
                      name="custom_link"
                      value={inputData?.custom_link}
                      onChange={handleInputChange}
                      type="url"
                      className="form-control"
                      placeholder="Ex: http://www.example.com"
                    />
                    {errors.custom_link && (
                      <small className="text-danger">
                        {errors.custom_link}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="card profile-card card-bx ">
            <div className="card-header">
              <h6 className="card-title">Venue Details</h6>
            </div>
            <div className="card-body">
              {(inputData?.event_type == "In-Person" ||
                inputData?.event_type == "Hybrid") && (
                <div className="row mb-3">
                  <div className="col-sm-3">
                    <label className="col-sm-6 col-form-label">
                      Venue Name
                    </label>
                    <input
                      name="venue_name"
                      value={inputData.venue_name}
                      onChange={handleInputChange}
                      className="form-control"
                      rows="2"
                      placeholder="Ex: ABC"
                    />
                    {errors.venue_name && (
                      <small className="text-danger">{errors.venue_name}</small>
                    )}
                  </div>
                </div>
              )}

              <div className="mb-3 row">
                <div className="col-sm-3">
                  <label className="col-sm-4 col-form-label">
                    Country<span className="asterisk">*</span>
                  </label>

                  <select
                    className="form-control"
                    name="country"
                    onChange={handleInputChange}
                  >
                    <option>Select Country</option>
                    {countriesList.map((value) => (
                      <option
                        value={value?.id}
                        selected={value?.id == inputData?.country}
                      >
                        {value?.name}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <small className="text-danger">{errors.country}</small>
                  )}
                </div>

                <div className="col-sm-3">
                  <label className="col-sm-4 col-form-label">
                    State<span className="asterisk">*</span>
                  </label>

                  <select
                    className="form-control"
                    name="state"
                    onChange={handleInputChange}
                  >
                    <option>Select State</option>
                    {stateList.map((value) => (
                      <option value={value?.id}>{value?.name}</option>
                    ))}
                  </select>
                  {errors.state && (
                    <small className="text-danger">{errors.state}</small>
                  )}
                </div>

                <div className="col-sm-3">
                  <label className="col-sm-4 col-form-label">
                    City<span className="asterisk">*</span>
                  </label>
                  <select
                    className="form-control"
                    name="city"
                    onChange={handleInputChange}
                  >
                    <option>Select City</option>
                    {cityList.map((value) => (
                      <option value={value?.id}>{value?.name}</option>
                    ))}
                  </select>

                  {errors.city && (
                    <small className="text-danger">{errors.city}</small>
                  )}
                </div>

                <div className="col-sm-3">
                  <label className="col-sm-4 col-form-label">
                    Pin Code<span className="asterisk">*</span>
                  </label>
                  <input
                    name="zip_code"
                    value={inputData?.zip_code}
                    onChange={handleInputChange}
                    type="number"
                    className="form-control"
                    placeholder="Ex: 123456"
                  />
                  {errors?.zip_code && (
                    <small className="text-danger">{errors?.zip_code}</small>
                  )}
                </div>
              </div>

              {(inputData?.event_type == "In-Person" ||
                inputData?.event_type == "Hybrid") && (
                <div className="row mb-3">
                  <div className="col-sm-6">
                    <label className="col-sm-6 col-form-label">
                      {" "}
                      Street Address
                    </label>
                    <textarea
                      name="address"
                      value={inputData.address}
                      onChange={handleInputChange}
                      className="form-control"
                      rows="3"
                      placeholder="Ex: ABC"
                    />
                    {errors.address && (
                      <small className="text-danger">{errors.address}</small>
                    )}
                  </div>
                </div>
              )}

              <MyMapComponent />
            </div>
          </div>

          {/* Date and Time Inputs */}
          <div className="card profile-card card-bx ">
            <div className="card-header">
              <h6 className="card-title">Event Timing</h6>
            </div>
            <div className="card-body">
              <div className="mb-3 row">
                <div className="col-md-6 col-xl-3">
                  <label className="col-md-8 col-form-label">
                    Start date<span className="asterisk">*</span>
                  </label>
                  {/* <DatePicker
                       selected={inputData?.start_date ? new Date(inputData?.start_date) : null}
                       onChange={(date) => handleDateChange(date, 'start_date')}
                       name="start_date"
                       placeholderText="Start Date"
                       className="picker-suit"
                       dateFormat="dd/MM/yyyy"
                     /> */}
                  <input
                    type="date"
                    value={inputData?.start_date}
                    name="start_date"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.start_date && (
                    <small className="text-danger">{errors.start_date}</small>
                  )}
                </div>
                <div className="col-md-6 col-xl-3">
                  <label className="col-md-8 col-form-label">
                    Start time<span className="asterisk">*</span>
                  </label>
                  <input
                    type="time"
                    value={inputData.start_time}
                    name="start_time"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.start_time && (
                    <small className="text-danger">{errors.start_time}</small>
                  )}
                </div>
                <div className="col-md-6 col-xl-3">
                  <label className="col-md-8 col-form-label">
                    End date<span className="asterisk">*</span>
                  </label>
                  {/* <DatePicker
                      selected={inputData?.end_date ? new Date(inputData?.end_date) : null}
                      onChange={(date) => handleDateChange(date, 'end_date')}
                      name="end_date"
                      placeholderText="End Date"
                      className="picker-suit"
                      dateFormat="dd/MM/yyyy"
                    /> */}
                  <input
                    type="date"
                    value={inputData.end_date}
                    name="end_date"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.end_date && (
                    <small className="text-danger">{errors.end_date}</small>
                  )}
                </div>
                <div className="col-md-6 col-xl-3">
                  <label className="col-md-8 col-form-label">
                    End time<span className="asterisk">*</span>
                  </label>
                  <input
                    type="time"
                    value={inputData.end_time}
                    name="end_time"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                  {errors.end_time && (
                    <small className="text-danger">{errors.end_time}</small>
                  )}
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-md-6 col-xl-3">
                  <label className="col-md-8 col-form-label">
                    Registration Deadline
                  </label>
                  <input
                    type="Date"
                    value={inputData.cut_off_date}
                    name="cut_off_date"
                    onChange={handleInputChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="card profile-card card-bx ">
            <div className="card-header">
              <h6 className="card-title">Event Schedule</h6>
            </div>
            <div className="card-body">
              <div className="mb-3 mb-0 d-flex gap-2">
                <div className="radio d-flex align-items-center">
                  <label className="form-check-label">
                    <input
                      type="radio"
                      value="detailed"
                      checked={manageMultiple === true}
                      onChange={handleRadioChange}
                      className="form-check-input me-1"
                    />
                    Create a Detailed Schedule
                  </label>
                </div>
                <div className="radio">
                  <label className="form-check-label">
                    <input
                      type="radio"
                      value="upload"
                      checked={manageMultiple === false}
                      onChange={handleRadioChange}
                      className="form-check-input me-1"
                    />
                    Upload Event Schedule
                  </label>
                </div>
              </div>

              {manageMultiple ? (
                scheduleDates.map((date) => {
                  const dateString = date.toISOString().split("T")[0]; // Format date as 'YYYY-MM-DD'
                  const schedulesForDate =
                    dynamicSchedules.find(
                      (schedule) => schedule.date === dateString
                    )?.events || [];

                  return (
                    <div
                      key={dateString}
                      className="create-event-save-btn p-3 mt-4 border border-2 rounded"
                    >
                      <h5>Schedules for {dateString}</h5>
                      <button
                        type="button"
                        onClick={() => addNewSchedule(dateString)}
                        className="p-1"
                      >
                        Add New Schedule
                      </button>
                      <div className="row">
                        {schedulesForDate.map((schedule, index) => (
                          <div
                            key={index}
                            className="col-md-4 schedule-item my-2 p-3"
                          >
                            <div className="mb-3">
                              <label>Title</label>
                              <input
                                type="text"
                                value={schedule.title}
                                onChange={(e) => {
                                  const updatedSchedules = [
                                    ...schedulesForDate,
                                  ];
                                  updatedSchedules[index].title =
                                    e.target.value;
                                  setDynamicSchedules((prevSchedules) => {
                                    const updatedPrevSchedules =
                                      prevSchedules.map((item) =>
                                        item.date === dateString
                                          ? {
                                              ...item,
                                              events: updatedSchedules,
                                            }
                                          : item
                                      );
                                    return updatedPrevSchedules;
                                  });
                                }}
                                className="form-control"
                                placeholder="Enter Title"
                              />
                            </div>
                            <div className="mb-3">
                              <label>Start Time</label>
                              <input
                                type="time"
                                value={schedule.start_time}
                                onChange={(e) => {
                                  const updatedSchedules = [
                                    ...schedulesForDate,
                                  ];
                                  updatedSchedules[index].start_time =
                                    e.target.value;
                                  setDynamicSchedules((prevSchedules) => {
                                    const updatedPrevSchedules =
                                      prevSchedules.map((item) =>
                                        item.date === dateString
                                          ? {
                                              ...item,
                                              events: updatedSchedules,
                                            }
                                          : item
                                      );
                                    return updatedPrevSchedules;
                                  });
                                }}
                                className="form-control"
                              />
                            </div>
                            <div className="mb-3">
                              <label>End Time</label>
                              <input
                                type="time"
                                value={schedule.end_time}
                                onChange={(e) => {
                                  const updatedSchedules = [
                                    ...schedulesForDate,
                                  ];
                                  updatedSchedules[index].end_time =
                                    e.target.value;
                                  setDynamicSchedules((prevSchedules) => {
                                    const updatedPrevSchedules =
                                      prevSchedules.map((item) =>
                                        item.date === dateString
                                          ? {
                                              ...item,
                                              events: updatedSchedules,
                                            }
                                          : item
                                      );
                                    return updatedPrevSchedules;
                                  });
                                }}
                                className="form-control"
                              />
                            </div>
                            <div className="mb-3">
                              <label>Description</label>
                              <textarea
                                value={schedule.description}
                                onChange={(e) => {
                                  const updatedSchedules = [
                                    ...schedulesForDate,
                                  ];
                                  updatedSchedules[index].description =
                                    e.target.value;
                                  setDynamicSchedules((prevSchedules) => {
                                    const updatedPrevSchedules =
                                      prevSchedules.map((item) =>
                                        item.date === dateString
                                          ? {
                                              ...item,
                                              events: updatedSchedules,
                                            }
                                          : item
                                      );
                                    return updatedPrevSchedules;
                                  });
                                }}
                                className="form-control"
                                placeholder="Enter description"
                              ></textarea>
                            </div>
                            <button
                              type="button"
                              onClick={() => deleteSchedule(dateString, index)}
                              className="p-1"
                            >
                              Delete Schedule
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })
              ) : (
                <>
                  <div className="col-md-12">
                    <h4>Images</h4>
                    <div className="my-3 d-flex justify-content-center">
                      <div className="creat_eevent-media-hub-uploadImageContainer">
                        <input
                          type="file"
                          accept="image/*"
                          name="image"
                          style={{ display: "none" }}
                          id="multipleImages"
                          multiple
                          onChange={handleImageChange}
                        />

                        <label
                          htmlFor="multipleImages"
                          className="imgPlaceholder"
                        >
                          <div className="flex flex-col cursor-pointer imgUploadIcon">
                            <img width="30" src={uplodIcon} alt="Upload Icon" />
                            <p>Select Images</p>
                          </div>
                        </label>
                      </div>
                    </div>

                    <div className="MediaHub-selected-images">
                      {images?.map((image, index) => (
                        <div key={index} className="MediaHub-image-preview">
                          <img
                            src={URL.createObjectURL(image)}
                            alt={`Selected ${index}`}
                            width="100"
                            className="m-2"
                          />
                          <button
                            onClick={() => handleRemoveImage(index)}
                            className="MediaHub-deleteImageButton"
                          >
                            ⛌
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <h4>Documents</h4>
                    <div className="my-3 d-flex justify-content-center">
                      <div className="creat_eevent-media-hub-uploadImageContainer">
                        <input
                          type="file"
                          accept=".pdf,.doc,.docx,.txt,.xlsx,.xls"
                          name="document"
                          style={{ display: "none" }}
                          id="DocumentUpload"
                          multiple // Allow multiple file selection
                          onChange={handleDocumentChange}
                        />

                        <label
                          htmlFor="DocumentUpload"
                          className="imgPlaceholder"
                        >
                          <div className="flex flex-col cursor-pointer imgUploadIcon">
                            <img width="30" src={uplodIcon} alt="Upload Icon" />
                            <p>Select Documents</p>
                          </div>
                        </label>
                      </div>
                    </div>

                    {/* Display Uploaded Documents */}
                    <div className="uploaded-documents">
                      {documents.map((document, index) => (
                        <div key={index} className="document-preview">
                          <img src={DocImg} />
                          <p className="text-center">{document.name}</p>
                          <button
                            onClick={() => handleRemoveDocument(index)}
                            className="deleteDocumentButton"
                          >
                            ⛌
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="card profile-card card-bx ">
            <div className="card-header">
              <h6 className="card-title">About Event</h6>
            </div>
            <div className="card-body">
              <div className="mb-3 row">
                <div className="col-sm-12">
                  <label className="col-sm-3 col-form-label">
                    Description<span className="asterisk">*</span>
                  </label>

                  <ReactQuill
                    value={inputData?.description}
                    onChange={handleQuillChange}
                    placeholder="Ex: House#94  Road#8  Abc City"
                  />
                  {errors.description && (
                    <small className="text-danger">{errors.description}</small>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Save and Continue Button */}
          <div className="d-flex justify-content-end gap-4">
            {/* <div className="create-event-back-btn">
                            <button type="button">Back</button>
                        </div> */}
            <div className="">
              <button className="btn btn-primary" type="submit">
                {btnLoading && <BtnLoader />}Save and continue
              </button>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default BasicInformation;
